import WorkOrderList from './WorkOrderList';

export default WorkOrderList;
